<template>
  <div v-if="title" class="breadcrumb p-4">
    {{ title }}
  </div>
</template>


<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
